module.exports = __webpack_public_path__ + "static/pensjonat-zima-489e6805108d0071d39051a15f183180.jpg";